import { hiprint } from 'vue-plugin-hiprint';
import { previewDeviceData } from './testData';

// 设备标签
export const providerDevice = function () {
  var addElementTypes = function (context) {
    context.removePrintElementTypes('providerDevice');
    context.addPrintElementTypes('providerDevice', [
      new hiprint.PrintElementTypeGroup('基础文本', [
        {
          tid: 'providerDevice.text0',
          title: '安徽省前视电力检测服务有限公司',
          type: 'text',
          options: {
            fontSize: 6.75,
            textAlign: 'center',
            width: 100
          }
        },
        {
          tid: 'providerDevice.text1',
          title: 'ANHUIQIANSHIJIANCE',
          type: 'text',
          options: {
            fontSize: 6.75,
            textAlign: 'center',
            width: 90
          }
        }
      ]),
      new hiprint.PrintElementTypeGroup('样品业务元素', [
        {
          tid: 'providerDevice.t1',
          title: '管理编号/出厂编号',
          type: 'text',
          options: {
            width: 90,
            fontSize: 5,
            hideTitle: true,
            field: 't1',
            testData: '(管理编号/出厂编号)'
          }
        },
        {
          tid: 'providerDevice.t2',
          title: '设备名称',
          type: 'text',
          options: {
            width: 40,
            fontSize: 6,
            hideTitle: true,
            field: 't2',
            testData: '(设备名称)'
          }
        },
        {
          tid: 'providerDevice.t3',
          title: '型号',
          type: 'text',
          options: {
            width: 40,
            fontSize: 6,
            hideTitle: true,
            field: 't3',
            testData: '(型号)'
          }
        },
        {
          tid: 'providerDevice.t4',
          title: '校准检定单位',
          type: 'text',
          options: {
            width: 40,
            fontSize: 6,
            hideTitle: true,
            field: 't4',
            testData: '(校准检定单位)'
          }
        },
        {
          tid: 'providerDevice.t5',
          title: '使用期限',
          type: 'text',
          options: {
            width: 40,
            fontSize: 6,
            hideTitle: true,
            field: 't5',
            testData: '(使用期限)'
          }
        },
        {
          tid: 'providerDevice.deviceUrl',
          title: '二维码',
          options: {
            fontSize: 6,
            field: 'deviceUrl',
            textType: 'qrcode',
            hideTitle: true,
            height: 40,
            width: 40,
            qrcodeType: 'qrcode',
            testData: '123456'
          }
        }
      ])
    ]);
  };
  return {
    addElementTypes: addElementTypes
  };
};

export const providers = [providerDevice()];
export const providerList = [
  {
    name: '设备',
    type: 0,
    value: 'providerDevice',
    previewData: previewDeviceData,
    width: 80,
    height: 30
  },
  {
    name: '设备',
    type: 0,
    value: 'providerDevice',
    previewData: previewDeviceData,
    width: 80,
    height: 30
  }
];
